export default __webpack_public_path__ + "static/media/create-ads-that-click-to-chat.40d570a2.png";